import { Navbar } from '@openx/components-core/lib/Navbar/Navbar.tsx';

import { Content } from './Content.tsx';
import { Layout } from './Layout.tsx';

export const Terms = () => (
  <Layout
    navbar={<Navbar helperMenuConfig={[]} userName="" showHelpIcon={false} showUserPanel={false} />}
    content={<Content />}
  />
);
